import type { ThreadEntry } from "../../../../api/threads/liveMessages";

/** Where a branch can start (F30, R-7): before a step's newest attempt, so the branch runs that step again. */
export interface BranchPoint {
  readonly stepKey: string;
  /** The fork's entry: the one before the step's newest request. */
  readonly atEntry: number;
}

/**
 * The steps a branch can start before, in the order the Thread reached them: for each step,
 * just before its newest request (a turn, a tool turn or a person step). "Branch before step 4"
 * keeps everything before step 4's newest attempt; the server's fork preview says what that
 * keeps and what runs again (T-10).
 */
export function branchPointsOf(entries: readonly ThreadEntry[]): readonly BranchPoint[] {
  const newest = new Map<string, number>();
  for (const entry of entries) {
    const payload = entry.payload;
    if (payload.kind === "turn_requested" || payload.kind === "tool_turn_requested" || payload.kind === "human_step_requested") {
      if (payload.step_key !== null) newest.set(payload.step_key, entry.number);
    }
  }
  return [...newest.entries()]
    .map(([stepKey, requested]) => ({ stepKey, atEntry: requested - 1 }))
    .filter((point) => point.atEntry > 0)
    .toSorted((left, right) => left.atEntry - right.atEntry);
}
